@use '@fukuri-admins/ui/layout' as *;

.container {
  display: flex;
  align-items: center;
  gap: spacing('8');
  width: 100%;
}

.rightSection {
  display: flex;
  align-items: center;
  gap: spacing('32');
  flex-shrink: 0;
  margin-left: auto;
}

.rangeSection {
  display: flex;
  align-items: center;
  gap: spacing('8');
  flex-shrink: 0;
}

.pageSection {
  display: flex;
  align-items: center;
  gap: spacing('12');
  flex-shrink: 0;
}

.navButtons {
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.text {
  @include typography('Jp/14_W3');
  color: text('Low');
  white-space: nowrap;
}
